import actionCreatorFactory from 'typescript-fsa';

/**
 * 課題情報
 */
export interface ITask {
	reportFileName: string;
	reportMstFlg: string;
	reportMstFlgNum: boolean;
	kikan: string;
	resultStatus: string;
	resultStatusNum: boolean;
	seq: string;
	expired: boolean;
}

const actionCreator = actionCreatorFactory();

/** 課題提出タイトル設定アクションクリエータ */
export const setTitle = actionCreator<{
	careerTitle: string;
	classTitle: string;
}>('SET_EXERCISE_TITLE');

/** 課題提出課題一覧設定アクションクリエータ */
export const setTasks = actionCreator<{
	tasks: ITask[];
}>('SET_EXERCISE_TASKS');

/** 課題提出情報初期化アクションクリエータ */
export const clearExerciseParams = actionCreator<{}>('CLEAR_EXERCISE_PARAMS');



// WEBPACK FOOTER //
// ./src/actions/exercise.ts